module.exports = __webpack_public_path__ + "img/mat_108.4095dc94.png";